module.exports = __webpack_public_path__ + "img/social03.745abab3.svg";